import { Form, Input, InputType } from "decorator-form";
import ButtonSelect from "common/form/widgets/common/ButtonSelect";
import { registerWidget } from "common/form/register";
import IOption from "common/models/IOption";

export enum ListTypeOptions {
	NONE = "none",
	ROWS = "rows",
	CAROUSEL = "carousel"
}
const listTypeOptions: IOption[] = [
	{ value: ListTypeOptions.NONE, label: "List" },
	{ value: ListTypeOptions.ROWS, label: "Responsive Rows" },
	{ value: ListTypeOptions.CAROUSEL, label: "Carousel" }
];
const listTypeInput = registerWidget(ButtonSelect.withOptions(listTypeOptions), "string");

@Form({title:"Recommended Config"})
export default class RecommendedPanelConfig {
    
    @Input({type: InputType.NUMBER, title:"No of courses to display"})
    public pageSize?: number = 5;

    @Input({type: InputType.TEXT, title:"Header Text"})
    public title: string;

    @Input({type: InputType.TEXT, title:"Sub Title"})
    public subTitle: string;

    @Input({type: InputType.CHECKBOX, title:"Enable Bundles"})
    public bundlesEnabled: boolean;

    @Input({type: InputType.CHECKBOX, title:"Show Selected Preferences"})
    public showSelectedPreferences: boolean;

    @Input({type: InputType.TEXT, title:"Preferences Separator"})
    public separator: string = ", ";

    @Input({type: InputType.CHECKBOX, title:"Show Courses Always"})
    public showCoursesAlways: boolean;

    @Input({type: InputType.STRING_ARRAY, title:"Tag Set Names"})
    public tagSetNames: string[];

    @Input({type: listTypeInput, title: "View Type"})
	public view: ListTypeOptions;

}


// WEBPACK FOOTER //
// ./src/panels/recommended/RecommendedConfig.ts